<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <div class="text-h5">{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    
    <v-row no-gutters>
      <v-col cols="12">
        <!-- INICIO TABELA -->
        <v-data-table
          :headers="headers"
          :items="dadosTabela"
          :loading="isLoading"
          loading-text="Carregando questões..."
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-row >
                <v-col cols="8" sm="6">
                  <v-text-field hide-details v-model="searchTitle" label="Pesquisar por Código ou Tema"></v-text-field>
                </v-col>

                <v-col cols="8" sm="2">
                  <v-btn small @click="page = 1; recuperarQuestoes();">
                    Pesquisar
                  </v-btn>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                max-width="1000px"
                fullscreen
                hide-overlay
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="hidden-sm-and-down"
                    dark
                    color="blue"
                    right
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    @click="resetEditor"
                  >
                    novo
                  </v-btn>

                  <v-btn
                    class="hidden-md-and-up"
                    small
                    dark
                    fab
                    color="blue"
                    right
                    top
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar dark color="indigo darken-3">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ tituloModal }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn  text @click="save"> Salvar </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>

                  <v-card-text>
                    <v-divider></v-divider>

                    <v-tabs v-model="tab">
                      <v-tab key="abaQuestao">Questão</v-tab>
                      <v-tab key="abaResposta">Respostas</v-tab>
                    </v-tabs>
                    <!-- INICIO ABA QUESTÕES -->
                    <v-tabs-items v-model="tab">
                      <v-tab-item key="abaQuestao">
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field 
                                v-model="editedItem.codigo"
                                label="Código"
                                hide-details 
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select
                                :items="activeProductList"
                                v-model="produto"
                                item-text="nome"
                                item-value="idResidencia"
                                label="Produto"
                                hide-details
                                @change="filterTheme(produto)"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-select
                                :items="themeList"
                                v-model="editedItem.tema"
                                item-text="nome"
                                item-value="idTema"
                                return-object
                                label="Tema"
                                hide-details
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <text-editor
                                label="Pergunta"
                                ref="editor2"
                                v-model="editedItem.pergunta"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <text-editor
                                label="Comentário da pergunta"
                                ref="editor"
                                v-model="editedItem.comentario"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>
                      <!-- INICIO ABA RESPOSTAS -->
                      <v-tab-item key="abaResposta">
                        <v-form>
                          <v-col cols="12" sm="12" md="12">
                            <v-textarea
                              v-model="respostas.resposta"
                              label="Resposta"
                              hide-details
                            ></v-textarea>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-select
                              :items="itCorreta"
                              v-model="respostas.correta"
                              item-value="value"
                              item-text="text"
                              label="Correta"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-textarea
                              v-model="respostas.comentario"
                              label="Comentário da resposta"
                              hide-details
                            ></v-textarea>
                          </v-col>

                          <v-btn color="primary" :disabled="validarCamposResposta(respostas)" @click="inserir">
                            Inserir
                          </v-btn>
                        </v-form>

                        <v-spacer></v-spacer>

                        <v-data-table
                          :headers="headersResposta"
                          :items="editedItem.respostas"
                          dense
                        >
                          <template v-slot:[`item.resposta`]="{ item }">
                            <span v-if="!item.isEditing">{{
                              item.resposta
                            }}</span>
                            <v-text-field
                              v-else
                              class="mb-4"
                              v-model="respostaEditada"
                              label="Resposta"
                              hide-details
                            ></v-text-field>
                          </template>

                          <template v-slot:[`item.correta`]="{ item }">
                            <span v-if="!item.isEditing">{{
                              item.correta === 0 ? 'Sim' : 'Não'
                            }}</span>

                            <v-select
                              v-else
                              class="mb-4"
                              :items="itCorreta"
                              v-model="corretaSelect"
                              item-value="value"
                              item-text="text"
                              label="Correta"
                              hide-details
                            ></v-select>
                          </template>

                          <template v-slot:[`item.comentario`]="{ item }">
                            <span v-if="!item.isEditing">{{
                              item.comentario
                            }}</span>
                            <v-text-field
                              v-else
                              class="mb-4"
                              v-model="comentarioEditado"
                              label="Comentário"
                              hide-details
                            ></v-text-field>
                          </template>
                          <template v-slot:[`item.acao`]="{ item }">
                            <div v-if="!item.isEditing">
                              <v-icon
                                small
                                class="mr-2"
                                @click="editAnswer(item)"
                                >mdi-pencil</v-icon
                              >
                              <v-icon small @click="handleDeleteAnwser(item)"
                                >mdi-delete</v-icon
                              >
                            </div>
                            <div v-else>
                              <v-icon
                                small
                                class="mr-2"
                                @click="confirmEditAnwser(item)"
                                >mdi-check-circle</v-icon
                              >
                              <v-icon small @click="cancelEditAnwser(item)"
                                >mdi-close-circle</v-icon
                              >
                            </div>
                          </template>
                        </v-data-table>
                      </v-tab-item>
                      <!-- FIM ABA RESPOSTAS -->
                    </v-tabs-items>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)" >mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
            <v-icon small class="mr-2" @click="copyItem(item)">mdi-content-copy</v-icon>
          </template>

          <template v-slot:[`item.pergunta`]="{ item }">
            <span>{{ sanitize(item.pergunta) }}</span>
          </template>
          <template v-slot:[`item.tema.nome`]="{ item }">
            <span>{{ sanitize(item.tema.nome) }}</span>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4" sm="1">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per Page"
            @change="handlePageSizeChange"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import headers from '../../components/jsonsHelper/headers';
  import Questao from '../../models/questao';
  import TextEditor from '../../components/shared/TextEditor';
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      corretaSelect: '',
      respostaEditada: '',
      comentarioEditado: '',
      respostas: {
        resposta: '',
        correta: 1,
        comentario: '',
      },
      isEditingItem: false,
      tab: '',
      tituloPagina: 'Cadastro de Questões',
      headers: [],
      dialog: false,
      themeList: [],
      produto: '',
      itCorreta: [
        { value: 0, text: 'Sim' },
        { value: 1, text: 'Não' },
      ],
      dadosTabela: [],
      editedIndex: -1,
      editedItem: new Questao(),
      searchTitle: "",
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 15, 20, 30, 40, 50],
    }),

    components: {
      TextEditor,
    },

    computed: {
      ...mapState('question', ['questionList', 'isLoading']),
      ...mapState('theme', ['themeListByProduct']),
      ...mapState('product', ['activeProductList']),

      tituloModal() {
        return this.editedIndex === -1 ? 'Nova Questão' : 'Editar Questão';
      },
      
      headersResposta() {
        return [
          { text: 'Resposta', value: 'resposta' },
          { text: 'Correta', value: 'correta' },
          { text: 'Comentário', value: 'comentario' },
          {
            text: 'Ação',
            value: 'acao',
            sortable: false,
          },
        ];
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      }
    },
    
    created() {
      this.initialize();
    },

    mounted() {
      this.recuperarQuestoes();
    },

    methods: {
      ...mapActions('question', [ 'getQuestionList', 'getQuestionById', 'deleteQuestion', 
      'editQuestion', 'toggleEditItem', 'createQuestion', 'setNewAnswer']),
      ...mapActions('product', ['getProductListActive']),
      ...mapActions('theme', ['getThemeByProduct']),

      async initialize() {
        await this.getProductListActive();
        this.headers = headers.questaoHeaders;
      },

      async recuperarQuestoes() {
        const params = this.getRequestParams(
          this.page,
          this.pageSize,
          this.searchTitle
        );
        const resp = await this.getQuestionList(params);
        this.dadosTabela = resp.questoes
        this.totalPages = resp.totalPaginas;
      },

      getRequestParams( page, pageSize, search) {
        let params = {};

        if (page) params["page"] = page -1;
        if (pageSize) params["size"] = pageSize;
        if(search) params["search"] = search;

        return params;
      },

      handlePageChange(value) {
        this.page = value;
        this.recuperarQuestoes();
      },

      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
        this.recuperarQuestoes();
      },

      async filterTheme(idProduto) {
        await this.getThemeByProduct(idProduto);
        this.themeList = [...this.themeListByProduct];
      },

      async editItem(item) {
        this.editedIndex = this.questionList.indexOf(item);
        this.editedItem = await this.getQuestionById(item.idQuestao );
        this.produto = this.editedItem.tema.especialidade.residencia
        this.filterTheme(this.produto.idResidencia)
        this.isEditingItem = true;
        this.dialog = true;
      },

      async copyItem(item) {
        this.editedIndex = this.questionList.indexOf(item);
        this.editedItem = await this.getQuestionById(item.idQuestao );
        this.produto = this.editedItem.tema.especialidade.residencia
        this.filterTheme(this.produto.idResidencia)
        
        this.editedItem.idQuestao = null;
        this.editedItem.acerto = null;
        this.editedItem.dtCadastro = null;
        this.editedItem.favorito = null;
        this.editedItem.respostaUsuario = null;
        this.editedItem.respostas.forEach(resposta => {resposta.idResposta = null, resposta.idQuestao = null})

        console.log(this.editedItem)
        this.dialog = true;
      },

      deleteItem(item) {
        confirm(
          'Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)',
        ) &&
          this.deleteQuestion(item.idQuestao).then((status) => {
            status === 200 && this.recuperarQuestoes().then(() => this.close());
          });
      },

      editAnswer(item) {
          this.editedItem.respostas = this.editedItem.respostas.map(
            (itemMap) => {
              return {
                ...itemMap,
                isEditing: itemMap.resposta === item.resposta,
              };
            },
          );
          this.corretaSelect = item.correta;
          this.respostaEditada = item.resposta;
          this.comentarioEditado = item.comentario;
      },

      confirmEditAnwser() {
          this.editedItem.respostas = this.editedItem.respostas.map(
            (itemMap) => {
              if (itemMap.isEditing) {
                return {
                  ...itemMap,
                  resposta: this.respostaEditada,
                  correta: this.corretaSelect,
                  comentario: this.comentarioEditado,
                  isEditing: false,
                };
              } else {
                return {
                  ...itemMap,
                };
              }
            }
          );
      },

      async handleDeleteAnwser(item) {
        const index = this.editedItem.respostas.indexOf(item);
        this.editedItem.respostas.splice(index, 1);
      },

      cancelEditAnwser(item) {
        this.setNewAnswer(item);
        this.corretaSelect = '';
        this.respostaEditada = '';
        this.comentarioEditado = '';
      },

      close() {
        this.dialog = false;
        this.editedItem = new Questao();
        this.produto = '';
        this.editedIndex = -1;
        this.isEditingItem = false;
        this.tab = '';

      },
      
      async save() {
        const resp = this.isEditingItem
          ? await this.editQuestion(this.editedItem)
          : await this.createQuestion(this.editedItem);
        resp === 200 && this.recuperarQuestoes().then(() => this.close());
      },

      inserir() {
        const resposta = {
          resposta: this.respostas.resposta,
          correta: this.respostas.correta,
          comentario: this.respostas.comentario,
        };
        this.editedItem.respostas = this.editedItem.respostas
          ? [...this.editedItem.respostas, resposta]
          : [resposta];
        this.respostas.resposta = '';
        this.respostas.correta = 1;
        this.respostas.comentario = '';
      },

      validarCamposResposta(respostas){
        return respostas.resposta === '' ||
               respostas.correta === '' ||
               respostas.comentario === ''
      },

      resetEditor() {
        this.$refs.editor && this.$refs.editor.editor.setContent('');
        this.$refs.editor2 && this.$refs.editor2.editor.setContent('');
      },

      sanitize(string) {
        const sanitizedString = this.$sanitize(string, {
          allowedTags: [],
        });
        return sanitizedString;
      }
    },
  };
</script>

<style lang="scss">
  .v-application p {
    margin-bottom: 0 !important;
  }
  table {
    tr {
      td {
        span {
          display: block;
          max-width: 25em;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  @media screen and (max-width: 540px) {
    table {
      tr {
        td {
          span {
            max-width: 10em;
          }
        }
      }
    }
  }
</style>
